import { type ISellingExperienceApp } from 'store/entities/applications/interfaces';

import { getConfig } from './config';

export const getInactivityReasonAppId = (): string => getConfig().inactivityReasonAppId;

export const getFBMessengerAppId = (): string => getConfig().facebookMessengerApp;

export const getGoogleAnalyticsAppId = (): string => 'analytics';

export const getABCAppId = (): string => getConfig().appleBusinessChatAppId;

export const getKBAppId = (): string => getConfig().knowledgeBaseAppId;

export const getHelpDeskAppId = (): string => getConfig().helpdeskAppId;

export const getInsightsAppId = (): string => getConfig().insightsAppId;

export const getchatAnalyserAppId = (): string => getConfig().chatsAnalyserAppId;

export const getChatSentimentAppId = (): string => getConfig().chatSentimentAppId;

export const getSampleChatAppId = (): string => getConfig().sampleChatAppId;

export const getRtmSentimentWebhooksAppId = (): string => getConfig().rtmSentimentWebhooksAppId;

export const getAutoChatSummaryAppId = (): string => getConfig().autoChatSummaryAppId;

export const getHelpDeskAppNamespace = (): string => getConfig().helpDeskAppClientId;

export const getWhatsAppAppId = (): string => getConfig().whatsappBusinessAppId;

export const getSellingExperienceApps = (): ISellingExperienceApp[] => getConfig().sellingExperienceApps;

export const getSellingExperienceAppsIds = (): string[] => getConfig().sellingExperienceApps.map((app) => app.id);

export const getSellingExperienceAppsIdsWithMessageBox = (): string[] =>
  getConfig()
    .sellingExperienceApps.filter((app) => app.messageBoxWidgetId)
    .map((app) => app.id);

export const getAiAgentClientId = (): string => getConfig().aiAgentClientId;

export const getApiUsagePackageAppId = (): string => getConfig().apiUsagePackageAppId;

export const getApiUsageProPackageAppId = (): string => getConfig().apiUsageProPackageAppId;

export const getApiUsageProPlusPackageAppId = (): string => getConfig().apiUsageProPlusPackageAppId;
